<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Ürün listesi yükleniyor</div>
							</div>
						</template>
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-text-field flat solo-inverted hide-details prepend-inner-icon="search"
									v-model="filterText" placeholder="Ürün Ara"></v-text-field>

								<v-btn icon @click="editItem()">
									<v-icon>add_circle</v-icon>
								</v-btn>
							</v-toolbar>

							<v-list two-line>
								<template v-for="(item, itemIndex) in getItems">
									<v-list-tile :key="itemIndex" avatar @click="editItem(item)">
										<v-list-tile-content>
											<v-list-tile-title> {{item.name}} </v-list-tile-title>
											<v-list-tile-sub-title> {{item.categorie_name}} </v-list-tile-sub-title>
										</v-list-tile-content>
										<v-list-tile-action> 
											<FloatSpan :value="item.price" append="₺"/> 
										</v-list-tile-action>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>


				<v-dialog v-model="dialogEditor" persistent max-width="600px">
					<v-card>
						<v-card-title>
							<span class="headline" v-if="item.id">Düzenle</span>
							<span class="headline" v-if="!item.id">Yeni Ekle</span>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-md>
								<v-layout wrap>
									<v-flex xs12>
										<v-text-field label="Ürün Adı" v-model="item.name" outline></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-textarea label="Açıklama" v-model="item.description" outline></v-textarea>
									</v-flex>
									<v-flex xs12>
										<v-select v-model="item.id_categorie" :items="getCategories"  item-text="name" item-value="id" label="Ürün Kategorisi" outline ></v-select>
									</v-flex>
									<v-flex xs12>
										<div style="width:80px">
											<FloatInput label="Fiyat" v-model="item.price" outline />
										</div>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions class="pr-4 pl-4 pb-4">
							<v-btn color="error" round outline v-if="item.id" @click="askForRemove()">Sil</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="info" round outline v-if="item.id" @click="saveasItem()">Kopyala</v-btn>
							<v-btn color="warning" round outline @click="closeItem()">İptal</v-btn>
							<v-btn color="success" round outline @click="saveItem()">Kaydet</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>



				<v-dialog v-model="dialogRemove" persistent  max-width="290">
					<v-card> 
						<v-card-text color="error"> Silmek itediğine emin misin ? </v-card-text> 
						<v-card-actions> 
							<v-btn color="green darken-1" flat="flat" @click="closeForRemove()"> Vazgeç </v-btn> 
							<v-spacer></v-spacer>
							<v-btn color="error darken-1" flat="flat" @click="removeItem()"> EMİNİM </v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>





			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	import FloatSpan from "@/components/tools/FloatSpan.vue";
	import FloatInput from "@/components/tools/FloatInput.vue";
	export default {
		name: "TeklifProducts",
		components: {
			FloatSpan,
			FloatInput,
		},
		data() {
			return {
				isLoading: true,
				dialogEditor: false,
				dialogRemove: false,
				filterText: "",
				categories: [],
				items: [],
				item: {}
			}
		},
		mounted() {
			this.isLoading = true;
			this.loadCategories();
			this.loadItems();
		},
		methods: {
			loadCategories() { 
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/categories/", {
					params: {}
				}).then(response => {
					this.categories = response.body; 
				})
			}, 
			loadItems() {
				this.dialogEditor = false;
				this.dialogRemove = false;
				this.$http.get(process.env.VUE_APP_API_URL + "/teklif/products/", {
					params: {}
				}).then(response => {
					this.items = response.body;
					this.isLoading = false;
				})
			}, 
			editItem(item) {
				if (item) {
					this.item = JSON.parse(JSON.stringify(item))
				} else {
					this.item = {
						id : "",
						id_categorie : 0,
						name : "",
						description : "",
						price : 0.0,
					}
				}
				this.dialogEditor = true;
			},
			closeItem(e) { if (e) { this.loadAccounts(); } this.dialogEditor = false },
			askForRemove() { this.dialogEditor = false; this.dialogRemove = true },
			closeForRemove() { this.dialogEditor = true; this.dialogRemove = false },
			saveItem(){
				this.dialogEditor = false;
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/teklif/products/save", this.item, {
					params: { }
				}).then(response => { 
					this.loadItems();
				})
			},
			saveasItem(){
				this.dialogEditor = false;
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/teklif/products/saveas", this.item, {
					params: { }
				}).then(response => { 
					this.loadItems();
				})
			},
			removeItem(){
				this.dialogEditor = false;
				this.dialogRemove = false;
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/teklif/products/remove", this.item, {
					params: { }
				}).then(response => { 
					this.loadItems();
				})
			},
		},
		computed: {
			getItems() {
				var items = [];
				var filterText = this.filterText.toLowerCase();
				items = this.items.filter(function (item) {
					if (filterText != "") {
						if ( item.name.toLowerCase().indexOf(filterText) < 0 ) {
							return false;
						}
					}
					return true;
				})
				for(var i in items){
					for(var c in this.categories){
						if(this.categories[c].id == items[i].id_categorie){
							items[i].categorie_name = this.categories[c].name;
						}
					}
				}
				items.sort(function (a, b) {
					var nameA = a.name.toUpperCase();
					var nameB = b.name.toUpperCase();
					if (nameA < nameB) { return -1; }
					if (nameA > nameB) { return 1; }
					return 0;
				});
				return items;
			},
			getCategories(){
				var items = this.categories; 
				items.sort(function (a, b) {
					var nameA = a.name.toUpperCase();
					var nameB = b.name.toUpperCase();
					if (nameA < nameB) { return -1; }
					if (nameA > nameB) { return 1; }
					return 0;
				});
				return items;
			}
		}
	}
</script>

 